import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function GoogleAuthCallback() {
  const nav = useNavigate();
  const { googleLogin } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      toast.error("Sign-in did not complete. Please try again.");
      nav("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const u = await googleLogin(sessionId);
        window.history.replaceState({}, "", window.location.pathname);
        if (u.restored) toast.success(`Nice to see you again, ${u.name}!`);
        else if (u.new_user) toast.success(`Welcome, ${u.name}!`);
        else toast.success("Welcome back");
        const storedNext = sessionStorage.getItem("post_login_next");
        if (storedNext) {
          sessionStorage.removeItem("post_login_next");
          nav(storedNext, { replace: true });
        } else if (u.role === "employee") nav("/employee", { replace: true });
        else if (u.role === "counselor") nav("/counselor", { replace: true });
        else nav("/dashboard", { replace: true });
      } catch (err) {
        toast.error(formatApiError(err));
        nav("/login", { replace: true });
      }
    })();
  }, [nav, googleLogin]);

  return (
    <div className="max-w-md mx-auto px-6 py-24 text-center" data-testid="google-auth-callback">
      <p className="text-sm" style={{ color: "var(--text-secondary)" }}>Signing you in…</p>
    </div>
  );
}
